
















































import { Component, Vue } from "@zoovu/runner-browser-api";
import { ChoiceQuestionView } from "@zoovu/runner-web-design-base";

@Component({
  name: "ChoiceQuestionView",
  mixins: [ChoiceQuestionView]
})
export default class ChoiceQuestionViewExtended extends Vue {
  hasQuestionCustomWidthAttribute() {
    const { answersFullWidth } = this.question.parameters;
    return answersFullWidth && answersFullWidth === true;
  }
}
